import { useEffect } from 'react';
import { useSession } from '../../store/session';
import { setCompleteFeedback } from '../../telegram/haptics';
import { currentStreak, totalSetsRead } from '../../lib/streak';
import { plural } from '../../lib/plural';
import { ru } from '../../strings/ru';
import styles from './CompleteScreen.module.css';

export function CompleteScreen() {
  const activeSet = useSession((s) => s.activeSet);
  const exitSession = useSession((s) => s.exitSession);
  // Читаем после записи в историю — goNext уже её обновил
  const streak = currentStreak();
  const total = totalSetsRead();

  useEffect(() => {
    setCompleteFeedback();
  }, []);

  return (
    <div className={styles.screen}>
      <div className={styles.badge} aria-hidden="true">
        ✓
      </div>

      <h1 className={styles.title}>{ru.complete.title}</h1>
      <p className={styles.subtitle}>
        {activeSet === 'morning'
          ? ru.complete.subtitleMorning
          : ru.complete.subtitleEvening}
      </p>

      <dl className={styles.stats}>
        <div className={styles.stat}>
          <dt>{ru.complete.streak}</dt>
          <dd>
            {streak}
            <span className={styles.unit}>
              {plural(streak, ru.home.streakOne, ru.home.streakFew, ru.home.streakMany)
                .replace(' подряд', '')}
            </span>
          </dd>
        </div>
        <div className={styles.stat}>
          <dt>{ru.complete.totalRead}</dt>
          <dd>{total}</dd>
        </div>
      </dl>

      <button className={styles.button} onClick={exitSession}>
        {ru.complete.toHome}
      </button>
    </div>
  );
}
